import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Router)
Vue.use(VueAxios, axios)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/station',
      name: 'estacoes',
      component: () => import('./views/Estacoes.vue')
    },
    {
      path: '/car',
      name: 'frota',
      component: () => import('./views/Frota.vue')
    },
    {
      path: '/reserved',
      name: 'reserva',
      component: () => import('./views/Reserva.vue')
    },
    {
      path: '/confirmed',
      name: 'confirmado',
      component: () => import('./views/Confirmed.vue')
    },
    {
      path: '/failed',
      name: 'falhado',
      component: () => import('./views/Failed.vue')
    },
    {
      path: '/news',
      redirect: '/news/1'
    },
    {
      path: '/news/:id',
      name: 'noticias',
      component: () => import('./views/Noticias.vue')
    },
    {
      path: '/new',
      redirect: '/news/1'
    },
    {
      path: '/new/:id',
      name: 'noticias1',
      component: () => import('./views/paginas.vue')
    },
    {
      path: '/pags/:id',
      name: 'paginas',
      component: () => import('./views/paginas.vue')
    },
    {
      path: '/contacts',
      name: 'contactos',
      component: () => import('./views/Contactos.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/registar',
      name: 'registar',
      component: () => import('./views/registar.vue')
    },
    {
      path: '/recuperar',
      name: 'recuperar',
      component: () => import('./views/recuperar.vue')
    },

    // admin
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/admin.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin-driver',
      name: 'adminReservas',
      component: () => import('./views/admin-reserve.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin-client',
      name: 'adminReservas',
      component: () => import('./views/admin-reserve.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin-user',
      name: 'adminUser',
      component: () => import('./views/admin-user.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/pags',
      redirect: '/admin/pags/1'
    },
    {
      path: '/admin/pags/:id',
      name: 'adminPaginas',
      component: () => import('./views/admin-paginas.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/sitemap',
      name: 'adminSitemap',
      component: () => import('./views/admin-sitemap.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/users',
      redirect: '/admin/users/1'
    },
    {
      path: '/admin/users/:id',
      name: 'adminUtilizadores',
      component: () => import('./views/admin-utilizadores.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/contacts',
      name: 'adminContactos',
      component: () => import('./views/admin-contactos.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/languages',
      name: 'adminLinguas',
      component: () => import('./views/admin-linguas.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/questions',
      name: 'adminLinguas',
      component: () => import('./views/admin-perguntas.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/extras',
      name: 'adminExtras',
      component: () => import('./views/admin-extras.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    {
      path: '/admin/reserve',
      name: 'adminReservas',
      component: () => import('./views/admin-reserve.vue'),
      meta: { auth: true, redirect: '/login' }
    },
    /*
    {
      path: '/admin/reserve-all',
      name: 'adminReservasAll',
      component: () => import('./views/admin-reserve1.vue')
    },
    */

    // pagina nao existe
    {
      path: '*',
      name: 'erro',
      component: () => import('./views/404.vue')
    }
  ],
  mode: 'history',
  hashbang: false,
  base: __dirname,
  transitionOnLoad: true,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})
